
































































import { Component, Vue } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';

/**
 * Helpers
 */
import { getFullName } from "@/utils/users-helpers";

/**
 * Components
 */
import CreditDialog from './components/CreditDialog.vue';
import AccountCard from './components/AccountCard.vue';

/**
 * API
 */
import usersAPI from "@/api/users";

/**
 * Types
 */
import { SettingsResponseModel } from '@/api/settings';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');

/**
 * Page de la liste des comptes.
 */
@Component({
	components: { CreditDialog, AccountCard }
})
export default class AccountsListPage extends Vue {
	$refs!: {
		creditDialog: CreditDialog
	};

	/** Injections */
	getFullName = getFullName;

	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** Attributs */
	isLoading = false;
	isButtonLoading = false;
	currentUser: any = null;
	currentUserChildren: any[] = [];

	/** Méthodes */
	async created() {
		this.isLoading = true;
		this.currentUser = await usersAPI.getCurrent(); // TODO : changer par accounts/current si besoin de plus de détails
		this.currentUserChildren = await usersAPI.getChildren();
		this.isLoading = false;
	}

	get doesAnyAccountExists() {
		return (this.currentUser && this.currentUser.ownedAccounts && this.currentUser.ownedAccounts.length > 0)
			|| (this.currentUserChildren
				&& (this.currentUserChildren.filter((x) => x.accountsSharedWithMe.length > 0 || x.ownedAccounts.length > 0).length > 0)
			);
	}

	async handleOpenCreditDialog(id: number) {
		this.isButtonLoading = true;
		await this.$refs.creditDialog.open(id);
		this.isButtonLoading = false;
	}
}
